var $9ff0921234305393$exports = {};
// WebSocket configuration for Blob Chat
// This file can be replaced or modified for different environments (dev/prod)
// Determine environment - if running on localhost or 127.0.0.1, use dev config
const $9ff0921234305393$var$isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '';
// WebSocket URL configuration
const $9ff0921234305393$var$WS_CONFIG = {
    // Development (localhost)
    development: 'ws://localhost:8787/api/ws',
    // Production (Cloudflare Workers)
    // Option 1: Custom domain route (same domain as frontend) - REQUIRES ROUTE SETUP IN CF DASHBOARD
    production: 'wss://zdar.jelinek.work/api/ws'
};
// Export the WebSocket URL based on environment
window.WEBSOCKET_URL = $9ff0921234305393$var$isDevelopment ? $9ff0921234305393$var$WS_CONFIG.development : $9ff0921234305393$var$WS_CONFIG.production;
// Export environment flag for other scripts
window.IS_DEVELOPMENT = $9ff0921234305393$var$isDevelopment;
if ($9ff0921234305393$var$isDevelopment) {
    console.log('WebSocket URL configured:', window.WEBSOCKET_URL);
    console.log('Environment:', 'development');
}


export {$9ff0921234305393$exports as default};
//# sourceMappingURL=frontend.9d72eec5.js.map
